<template>

	<b-row class="mt-3">
		<b-col>
			


		</b-col>
	</b-row>

	
</template>


<script>

export default {
	name: "JobSchedule",

	components: {
		
	},

	data() {
		return {
			
		};
	},

	computed: {
		
	},

	created() {
		
	},

	methods: {
		
	},
};
</script>


// WEBPACK FOOTER //
// src/components/job/job-schedule.vue